import { DateTime } from 'luxon'
import React, { useContext, useEffect, useState } from 'react'
import { useForm } from 'react-hook-form'
import { AppContext } from '../../context/AppContext'
import { GymMemberData } from '../../types/types'
import Button from '../buttons/Button/Button'
import useGym from '../../hooks/useGym'
import SegmentedInput from '../inputs/SegmentedInput/SegmentedInput'
import ToggleInput from '../inputs/ToggleInput/ToggleInput'
import Avatar from '../atoms/Avatar/Avatar'
import Modal from './Modal'

type Props = {
  isVisible: boolean
  isLoading?: boolean
  onCancel: () => void
  onConfirm: () => void
}

type FieldValues = {
  accessCode: string
}

const EditAccessCode = ({ isVisible, onCancel, onConfirm }: Props) => {
  const { currentSpace } = useContext(AppContext)

  const { register, unregister, reset, handleSubmit, setFocus } =
    useForm<FieldValues>()
  const { error, setError, isLoading, updateGymInfo } = useGym({
    onComplete: () => {
      reset()
      onConfirm()
    },
    joinMode: false,
  })

  const save = (data: FieldValues) => {
    console.log('submiting')
    updateGymInfo('accessCode', data.accessCode.trim().toLowerCase())
  }

  useEffect(() => setFocus('accessCode'), [isVisible, error])

  return (
    <Modal
      isVisible={isVisible}
      onCancel={() => {
        reset()

        onCancel()
      }}
      size="small"
      title="Edit Access Code"
      buttons={{
        secondary: { onClick: onCancel },
        primary: {
          onClick: handleSubmit(save),
          label: 'Save',
          isSubmitButton: true,
          disabled: error ? true : false,
          isLoading: isLoading,
        },
      }}
    >
      <form onSubmit={handleSubmit(save)}>
        <input
          defaultValue={currentSpace?.accessCode ? currentSpace.accessCode : ''}
          maxLength={6}
          {...register('accessCode', { onChange: () => setError(null) })}
          style={{
            borderColor: error ? 'var(--accent-red)' : '',
          }}
          className="accessCode"
        />
        {error && (
          <p
            style={{
              marginTop: '8px',
              color: 'var(--accent-red)',
              textAlign: 'center',
            }}
          >
            {error}
          </p>
        )}
      </form>
    </Modal>
  )
}

export default EditAccessCode
